import ForgotPassword from '@/app/auth/forgot-password'

export default ForgotPassword
